module.exports = __webpack_public_path__ + "img/planta_baixa_01.ed764856.jpeg";